export interface Suggestion {
  query: string;
}

export interface AutocompleteGETRequest {
  prefix: string;
  maxResults?: number;
}

export interface AutocompleteGETResponse {
  suggestions: Suggestion[];
}

export enum ContentType {
  MODULE = 'MODULE',
}

export enum ContentProgressStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}

export interface SearchItem {
  resourceId: string;
  resourceType: ContentType;
  title: string;
  description?: string;
  thumbnailLink?: string;
  contentProgressStatus?: ContentProgressStatus;
  createdAt?: number;
  updatedAt?: number;
  isActive?: boolean;
  owner?: string;
}

export interface AutocompleteV2Request {
  query: string;
  maxSuggestions?: number;
  maxModules?: number;
  clientId: string;
  selLocale?: string;
}

export interface AutocompleteV2Response {
  suggestions: Suggestion[];
  modules: SearchItem[];
}
